export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">关于桃子视频，你可能想了解的信息都在这里</p>

        <div className="max-w-3xl mx-auto space-y-4">
          {/* FAQ 1 */}
          <div className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60">
            <h3 className="text-base font-semibold text-foreground-900 mb-2 flex items-center gap-2">
              <i className="ri-question-answer-line text-primary-500 text-lg"></i>
              桃子视频是否需要注册或付费？
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              桃子视频目前所有影视资源均可免费在线观看，无需注册会员，无需付费订阅。打开网站就能直接搜索和播放你喜欢的电影、电视剧、综艺和动漫内容。
            </p>
          </div>

          {/* FAQ 2 */}
          <div className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60">
            <h3 className="text-base font-semibold text-foreground-900 mb-2 flex items-center gap-2">
              <i className="ri-question-answer-line text-accent-500 text-lg"></i>
              视频播放画质怎么样？会缓冲卡顿吗？
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              平台聚合了香蕉视频、西瓜视频、蜜桃视频等多个水果品牌的高清片源，大部分内容提供 1080P 超清画质。采用多 CDN 加速节点，播放流畅不缓冲，观影体验与主流视频平台相当。
            </p>
          </div>

          {/* FAQ 3 */}
          <div className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60">
            <h3 className="text-base font-semibold text-foreground-900 mb-2 flex items-center gap-2">
              <i className="ri-question-answer-line text-secondary-500 text-lg"></i>
              资源更新频率如何？新上映的电影什么时候能看到？
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              桃子视频每日更新超过 200 部影视资源。热门院线电影通常在上映后 1-3 天内上线；电视剧和综艺与播出平台同步更新；动漫番剧每周随日本播出进度更新。资源更新速度和覆盖面在同类平台中名列前茅。
            </p>
          </div>

          {/* FAQ 4 */}
          <div className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60">
            <h3 className="text-base font-semibold text-foreground-900 mb-2 flex items-center gap-2">
              <i className="ri-question-answer-line text-primary-500 text-lg"></i>
              移动端可以观看吗？有没有APP？
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              桃子视频完美适配手机、平板等移动设备浏览器，无需下载 APP 即可在移动端流畅观看。同时我们也在积极开发专属移动应用，敬请期待。在手机浏览器中访问桃子视频即可获得与桌面端同样出色的观影体验。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}